import React from "react";
import { Link } from "react-router-dom";
import logo from "../assets/logo/footer_logo.png";

// get current year
const year = new Date().getFullYear();

const Footer = () => {
  return (
    <footer className="footer" style={{ backgroundColor: "#111111", color: "#fff" }}>
      <div className="container">
        <div className="row">
          <div className="col-lg-4 col-md-6 col-sm-6">
            <div className="footer__about">
              <div className="footer__logo">
                <Link to="/">
                  <img src={logo} alt="" />
                </Link>
              </div>
              <p style={{ color: "#aaa" }}>
                Welcome to Asbestos Logistics, a leading logistics and
                industrial waste management company. Our mission is to provide
                innovative, sustainable solutions for your waste management
                needs.
              </p>
              <div className="footer__social">
                <Link to="/">
                  <span className="social_facebook" style={{ color: "#fff" }}></span>
                </Link>
                <Link to="/">
                  <span className="social_twitter" style={{ color: "#fff" }}></span>
                </Link>
                <Link to="/">
                  <span className="social_linkedin" style={{ color: "#fff" }}></span>
                </Link>
                <Link to="/">
                  <span className="social_pinterest" style={{ color: "#fff" }}></span>
                </Link>
              </div>
            </div>
          </div>
          <div className="col-lg-2 offset-lg-1 col-md-6 col-sm-6">
            <div className="footer__widget">
              <h5 style={{ color: "#fff" }}>Quick links</h5>
              <ul>
                <li>
                  <Link to="/about" style={{ color: "#aaa" }}>About</Link>
                </li>
                <li>
                  <Link to="/services" style={{ color: "#aaa" }}>Services</Link>
                </li>
                <li>
                  <Link to="/contact" style={{ color: "#aaa" }}>Contact</Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 col-sm-6">
            <div className="footer__widget">
              <h5 style={{ color: "#fff" }}>Contacts</h5>
              <ul className="address">
                <li style={{ color: "#aaa" }}>
                  <span className="icon_pin" style={{ color: "#ff5f2a" }}></span> 530 Blackhawk Park Avenue
                  Rockford, IL 61104
                </li>
                <li style={{ color: "#aaa" }}>
                  <span className="icon_phone" style={{ color: "#ff5f2a" }}></span> (331) 330-7043
                </li>
                <li style={{ color: "#aaa" }}>
                  <span className="icon_phone" style={{ color: "#ff5f2a" }}></span> (510) 485-9219
                </li>
                <li>
                  <span className="icon_mail" style={{ color: "#ff5f2a" }}></span>
                  <a href="mailto:support@asbestoslogistics.com" style={{ color: "#aaa" }}>
                    support@asbestoslogistics.com
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="footer__copyright" style={{ borderTop: "1px solid rgba(255,255,255,0.1)", marginTop: "30px", paddingTop: "20px" }}>
        <div className="container">
          <div className="row">
            <div className="col-lg-9 col-md-8">
              <div className="footer__copyright__text">
                <p style={{ color: "#aaa" }}>
                  Copyright Asbestos Logistics &copy;
                  {year} All rights reserved
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
